$(function() {
  var urlHash = location.hash;
  if(urlHash) {
    $('.description_content_block').not($(urlHash)).hide();
    var targetTabHash = $('.tab a[href$="' + urlHash + '"]');
    var target = targetTabHash.parent();
    if(targetTabHash.length > 0){
      $('.tab').removeClass('current');
      target.addClass('current');
    }
  } else {
    var $secondTab = $('.tab').eq(1);
    var targetId = $secondTab.find('a').attr('href');
    $('.tab').removeClass('current');
    $secondTab.addClass('current');
    $('.description_content_block').not($(targetId)).hide();
  }
  $('.tab a').on('click',function(e){      
      $('.tab').removeClass('current');
      $(this).parent().addClass('current');
      $('.description_content_block').not($($(this).attr('href'))).hide();
      $($(this).attr('href')).fadeIn(500);
      e.preventDefault();
  });
});